
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cotizador",
      function () {
        return require("private-next-pages/cotizador.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cotizador"])
      });
    }
  